const formatters = new Map<string, Intl.NumberFormat>()

const formatter = (currency: string, locale: string) => {
    const key = `${currency}::${locale}`

    if (!formatters.has(key)) {
        formatters.set(
            key,
            new Intl.NumberFormat(locale, {
                style: 'currency',
                currency,
            }),
        )
    }

    return formatters.get(key) as Intl.NumberFormat
}

export const formatPrice = (price: number, currency = 'BRL', locale = 'pt-BR') =>
    formatter(currency, locale).format(price)

export const formatShippingEstimate = (estimate: string) => {
    const [, time, type] = estimate.split(/(\d+)/)

    const isSingular = time === '1'
    const timeValue = parseInt(time, 10); // Converte o tempo para um número

    // Verifica se o tempo é 0 e retorna a mensagem desejada
    if (timeValue === 0) {
        return "Hoje até as 20hs"; // Retorna a mensagem desejada para 0 dias
    }

  if (type === 'bd') return `${time} ${isSingular ? 'dia útil' : 'dias úteis'}`
  if (type === 'd') return `${time} ${isSingular ? 'dia' : 'dias'}`
  if (type === 'h') return `${time} ${isSingular ? 'hora' : 'horas'}`
}
